import { Winda } from "./Winda";

export const getCookiesDomain = () => {
  const domain = Winda.isPresent ? window.location.hostname : "";
  let cookiesDomain = domain !== "localhost" ? ".brex.com" : "localhost";
  if (domain.indexOf("vercel") > -1) {
    cookiesDomain = domain;
  }

  return cookiesDomain;
};
